import { IPcbLineShapeStyles, LayerOrientation } from "@buildwithflux/models";
import { Vector2 } from "three";
import { createDashedTracer } from "./support/dashedTracer";
import { createRectanglePath } from "./support/rectanglePath";
import { getModule, getRotatedPosition, toMm } from "./support/utils";
// TODO: implement support for rounded corners of differing radii
export const mapRectangle = (rect, context, postprocess) => {
    const br = rect.bakedRules;
    if (!br) {
        return null;
    }
    postprocess(() => {
        const module = getModule(br.layer, context);
        if (br.strokeStyle === IPcbLineShapeStyles.dashed) {
            const path = createRectanglePath(br);
            const { shape, dashes } = createDashedTracer(path, br);
            // TODO: dedupe with mapCircle()
            module.fp_poly = module.fp_poly ?? [];
            module.fp_poly = module.fp_poly.concat(dashes.map(({ angle, position }) => ({
                pts: shape
                    .map((point) => point
                    .clone()
                    .rotateAround(new Vector2(0, 0), angle)
                    .add(new Vector2(position.x, position.y)))
                    .map((point) => {
                    const start = getRotatedPosition({ x: point.x, y: point.y, z: 0 }, br.rotationRelativeToDocument);
                    return {
                        x: toMm(start.x + br.positionRelativeToDocument.x),
                        y: -toMm(start.y + br.positionRelativeToDocument.y),
                    };
                }),
                layer: br.layer === LayerOrientation.top ? "F.SilkS" : "B.SilkS",
                width: 0,
            })));
        }
        else {
            const scaleX = br.scale.x;
            const scaleY = br.scale.y;
            // TODO: fix this - it's a hack to find a middle ground between x and y scale for
            // stroke width. Gerber doesn't appear to support 2D scaling of stroke width. The
            // proper fix here is to generate raw polygonal geometry where 2D scaling is applied
            // consistently as on the editor canvas. Prefixing with TEMP_ to indicate this is a
            // temporary solution.
            const TEMP_scaleAvg = (scaleX + scaleY) / 2;
            const startX = br.startPosition.x;
            const startY = br.startPosition.y;
            const endX = br.endPosition.x;
            const endY = br.endPosition.y;
            const lines = [
                { start: { x: startX, y: startY }, end: { x: endX, y: startY } },
                { start: { x: endX, y: startY }, end: { x: endX, y: endY } },
                { start: { x: endX, y: endY }, end: { x: startX, y: endY } },
                { start: { x: startX, y: endY }, end: { x: startX, y: startY } },
            ].map((line) => {
                line.start.x *= scaleX;
                line.start.y *= scaleY;
                line.end.x *= scaleX;
                line.end.y *= scaleY;
                const start = getRotatedPosition({ ...line.start, z: 0 }, br.rotationRelativeToDocument);
                const end = getRotatedPosition({ ...line.end, z: 0 }, br.rotationRelativeToDocument);
                return {
                    start: {
                        x: toMm(br.positionRelativeToDocument.x + start.x),
                        y: -toMm(br.positionRelativeToDocument.y + start.y),
                    },
                    end: {
                        x: toMm(br.positionRelativeToDocument.x + end.x),
                        y: -toMm(br.positionRelativeToDocument.y + end.y),
                    },
                    width: toMm((br.strokeWidth ?? 0) * TEMP_scaleAvg),
                    layer: br.layer === LayerOrientation.top ? "F.SilkS" : "B.SilkS",
                };
            });
            module.fp_line = module.fp_line ?? [];
            module.fp_line.push(...lines);
        }
    });
    return null;
};
//# sourceMappingURL=mapRectangle.js.map